import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { WithApp } from 'contexts/appContext';
import { useParams } from 'react-router';

// Import Components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardHeader from 'components/Card/CardHeader.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardBody from 'components/Card/CardBody.js';
import ReactTable from 'components/ReactTable/ReactTable.js';

// @material-ui/icons
import { Receipt } from '@material-ui/icons';

import styles from 'assets/jss/material-dashboard-pro-react/views/regularFormsStyle';
import { wsGet } from 'services/WService.js';
import { currency } from 'hooks/Pipe.js';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  ...styles,
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper
  },
  cardIconTitle: {
    color: 'black',
    fontWeight: 'bold'
  },
  marginRight: {
    float: 'right',
    marginTop: '-30px'
  },
  paper: {
    padding: theme.spacing(2),
    '& h6': {
      fontSize: 13,
      fontWeight: 'bold'
    },
    '& h5': {
      fontSize: 15,
      fontWeight: 400
    },
    marginBottom: '10px'
  }
}));

export default WithApp(function DistributionTracking() {
  const classes = useStyles();
  const { id } = useParams();

  const [listDTDetail, setListDTDetail] = useState([]);
  const [listDTHR, setListDTHR] = useState({});

  const columns = [
    { Header: '#', accessor: 'id', width: 80 },
    { Header: 'HR', accessor: 'hr', width: 100, align: 'center', },
    { Header: 'Hora.Liq', accessor: 'fecusu', width: 100 },
    { Header: 'Tipo de pago', accessor: 'payType', width: 150, align: 'center', },
    { Header: 'Estado', accessor: 'state', width: 150, align: 'center', },
    { Header: 'Liquidación', accessor: 'liquidation', width: 150 },
    { Header: 'S/. facturados', accessor: 'facturedSoles', width: 130, align: 'right', },
    { Header: 'S/. devueltos', accessor: 'returnSoles', width: 130, align: 'right', },
    { Header: 'Cliente', accessor: 'customer', width: 130 },
    { Header: 'N° Doc.', accessor: 'docNumber', width: 130 },
    { Header: 'Parcial', accessor: 'enablePartial', width: 80, align: 'center', },
    { Header: '', accessor: 'actions', excelEnabled: false, width: 10 }
  ];

  const listStates = [
    { id: 'N', name: 'Nuevo' },
    { id: 'W', name: 'En proceso' },
    { id: '1', name: 'Liq. de mercaderia' },
    { id: '2', name: 'Liq. de mercaderia +' },
    { id: '3', name: 'Liq. de documento' },
    { id: '4', name: 'Liq. de documento +' },
    { id: 'L', name: 'Liq. HR' },
    { id: '5', name: 'Cerrado' },
    { id: 'A', name: 'Anulado' }
  ];

  async function getDocumentTrackingDetail(codProg) {
    let response = await wsGet('deliv/sheet-distribution', codProg);
    if (response.success) {
      setListDTDetail(response.data.documents);
      setListDTHR(response.data);
    }
  }

  useEffect(() => {
    getDocumentTrackingDetail(id);
  }, [id]);

  return (
    <div>
      <GridContainer>
        <GridItem sm={12} xs={12} xl={12}>
          <Card>
            <CardHeader icon>
              <CardIcon color="primary">
                <Receipt />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>Detalle de reparto</h4>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={6} sm={4} md={3}>
                  <h6>N° HR</h6>
                  <h5>{listDTHR.codprog || '-'}</h5>
                </GridItem>
                <GridItem xs={6} sm={4} md={3}>
                  <h6>Jefe de reparto</h6>
                  <h5>{listDTHR.manager_name || '-'}</h5>
                </GridItem>
                <GridItem xs={6} sm={4} md={3}>
                  <h6>Placa</h6>
                  <h5>{listDTHR.vehicle_plate || '-'}</h5>
                </GridItem>
                <GridItem xs={6} sm={4} md={3}>
                  <h6>Peso</h6>
                  <h5>{parseFloat(listDTHR.weight).toFixed(2) || '-'}</h5>
                </GridItem>
                <GridItem xs={6} sm={4} md={3}>
                  <h6>Volumen</h6>
                  <h5>{parseFloat(listDTHR.volume).toFixed(2) || '-'}</h5>
                </GridItem>
                <GridItem xs={6} sm={4} md={3}>
                  <h6>Zona</h6>
                  <h5>{listDTHR.base_zone_description || '-'}</h5>
                </GridItem>
                <GridItem xs={6} sm={4} md={3}>
                  <h6>Cant. pedidos</h6>
                  <h5>{parseFloat(listDTHR.total_orders).toFixed(0) || '-'}</h5>
                </GridItem>
                <GridItem xs={6} sm={4} md={3}>
                  <h6>Estado</h6>
                  <h5>{listStates.find(state => state.id === listDTHR.estado)?.name || '-'}</h5>
                </GridItem>
                <GridItem xs={6} sm={4} md={3}>
                  <h6>Inicio Jornada</h6>
                  <h5>{listDTHR.hora_apertura !== null ? moment(listDTHR.hora_apertura).format('LT') : '-'}</h5>
                </GridItem>
                <GridItem xs={6} sm={4} md={3}>
                  <h6>Primera liquidación</h6>
                  <h5>{listDTHR.primera_liquidacion !== null ? moment(listDTHR.primera_liquidacion).format('LT') : '-'}</h5>
                </GridItem>
                <hr style={{ width: '98%' }} />
                <GridItem sm={12} xs={12} xl={12}>
                  <ReactTable
                    defaultWidth="1300"
                    columns={columns}
                    data={listDTDetail.map((item, i) => ({
                      id: i + 1,
                      hr: item.codprog,
                      fecusu: item.updatedate !== null ? moment(item.updatedate).format('LT') : '-',
                      payType: item.PymntGroup,
                      state: item.state == 'O' ? 'Abierto' : 'Cerrado',
                      liquidation:
                        listStates.findIndex((obj) => obj.id == item.liqstatus) >= 0
                          ? listStates[listStates.findIndex((obj) => obj.id == item.liqstatus)].name
                          : '-',
                      facturedSoles: currency(item.doctotal),
                      returnSoles: currency(item.sumapply),
                      customer: item.cardname,
                      docNumber: item.numero,
                      enablePartial: item.parcial == 'N' ? 'No' : 'Si',
                      actions: ''
                    }))}
                  />
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
});
